import {Keycode} from '../../constants';

export const initHeader = () => {

  const headerElement = document.querySelector( 'header' );
  const button = document.querySelector( '.burger-btn' );
  const burgerList = headerElement.querySelector( '.header-list' );
  const contactsPage = document.querySelector( 'section.contacts' );

  let count = 0;

  if ( contactsPage ) {
    headerElement.classList.add('contact-page');
  }

  const toogleMenu = ( e ) => {

    const btnBurger = button.querySelector( 'div' );
    const telBurgerActive = headerElement.querySelector( '.header-link>li>.tel' );
    const searchBurgerActive = headerElement.querySelector( '.header-link>li>.search' );
    const logo = headerElement.querySelector( '.logo' );

    btnBurger.classList.toggle( 'burger-menu--active' );
    burgerList.classList.toggle( 'active' );

    button.classList.toggle( 'menu-active' );
    telBurgerActive.classList.toggle( 'menu-active' );
    searchBurgerActive.classList.toggle( 'menu-active' );
    headerElement.classList.toggle( 'menu-active' );
    logo.classList.toggle( 'menu-active' );
    
    if(count == 0) {
    } else {
      btnBurger.classList.toggle( 'burger-menu--closed' );
    }

    count++;

    document.body.classList.toggle( 'menu-open' );

    if (document.body.classList.contains( 'menu-open' ) )
    {
      document.firstElementChild.style.overflow = 'hidden';
    } else {
      document.firstElementChild.style.overflow = '';
    };

    const menuOpen = () => {

      const animElement = Array.from( document.querySelectorAll( '.animate-el' ) );
      const liElement = Array.from( document.querySelectorAll( '.header-list>ul>li' ) )
      const letLink = document.querySelector('.search.menu-active');

      if( document.body.classList.contains('menu-open') ) {
        animElement.forEach( ( el ) => {el.classList.add( 'animate' )} );
        liElement.forEach( ( el ) => {
          el.classList.add( 'animate' );
          for ( let index = 0; index < liElement.length; index++ ) {
            liElement[index].style.animationDelay = 0.2 + (index * 0.07) + 's';
          };
        }
          );
      } else {
        animElement.forEach( ( el ) => {el.classList.remove( 'animate' )} );
        liElement.forEach( ( el ) => {el.classList.remove( 'animate' )} );
      }
    };
    
    menuOpen();


  };

  button.addEventListener('click', e => {
    e.preventDefault();
    toogleMenu();
  });

  const closeMenu = ( evt ) => {
		if ( evt.keyCode === Keycode.ESC || evt.target.closest( 'a.logo' ) )
		{
			if ( headerElement.classList.contains( 'menu-active' ) )
			{
				evt.preventDefault();
				toogleMenu();
			}
		}

		headerElement.removeEventListener( 'keyup', closeMenu );
		headerElement.removeEventListener( 'click', closeMenu );
	};

	document.body.addEventListener( 'keyup', ( evt ) => closeMenu( evt ) );
	document.body.addEventListener( 'click', ( evt ) => closeMenu( evt ) );



  document.addEventListener( 'click', ( e ) => {
    const target = e.target;
    const itMenu = target == burgerList || burgerList.contains(target);
    const itHamburger = target == button;
    const menuActive = burgerList.classList.contains('active');

    if (!itMenu && !itHamburger && menuActive) {
      toogleMenu();
    }
  })

  if ( !headerElement.classList.contains('header-light') ) {
     const headerChenged = () => {
      const headerElement = document.querySelector('header');
      const firstComponent = document.querySelector('main>section');
      const documentHeight = document.documentElement.scrollTop;
      const headerHeight = headerElement.scrollHeight;
      
      if ( documentHeight > +firstComponent.scrollHeight - headerHeight) {
         headerElement.classList.add( 'header-light' );
      } else {
         headerElement.classList.remove( 'header-light' );
      }
      
     };
     window.addEventListener( 'scroll', headerChenged );
    //  window.addEventListener( 'resize', headerChenged );
  } else {
     headerElement.classList.add( 'header-light' );
  }
};
